import { of } from './of';
import { concatAll } from '../operators/concatAll';
export function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return concatAll()(of.apply(void 0, observables));
}
//# sourceMappingURL=concat.js.map